import chevron from 'src/assets/images/chevron.svg';
import styled from 'styled-components';
import { Black, Black2, MangoBlue } from '../../styles/colours';
import { DemiBold, Regular } from '../../styles/fonts';

export const StyledBreadcrumb = styled.ol.attrs({ 'data-type': 'breadcrumbs' })`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 1rem 0;
  margin: 0;

  list-style: none;

  li + li:before {
    display: inline-block;
    padding: 0 1rem;
    content: url(${chevron});
    color: ${Black2};
  }

  a {
    text-decoration: none;
    color: ${MangoBlue};
    font-family: ${DemiBold};
  }

  li:last-child a {
    color: ${Black};
    font-family: ${Regular};
  }
`;
